import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import jquery from 'jquery'
import './plugins/element'
import './plugins/elementAddress'
import './plugins/util'
import './styles/index.scss'
import './plugins/dateExt'
import './icons'
import './permission'
import Print from 'vue-print-nb'
import './utils/auth-directive'
import './utils/filters'
import appConfig from '@/utils/config'

Vue.config.productionTip = false// 似乎未使用
Vue.prototype.newSearchShow = appConfig.newSearchShow
Vue.prototype.$_ = require('lodash')
Vue.use(Print)
// 全局自定义语言包
// Vue.prototype.language = appConfig.zh
// 全局自定义报表配置
Vue.prototype.ReportConfig = appConfig.report
Vue.prototype.$ = jquery

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
